<template>
  <kt-panel>
    <form
      @submit.prevent="submitRequest($event, query)"
      id="single-request-form"
      class="kt-form p-3 my-4"
    >
      <div
        class="container p-3 pt-5 my-4 border in-border-header"
        style="padding-top: 1.5rem !important"
      >
        <kt-form-section is_first>
          <div class="section-header">ایجاد فاکتور</div>
          <kt-col lg="8" md="8" xs="12">
            <kt-form-group>
              <div class="d-flex align-items-center w-75">
                <div class="dropdown w-75">
                  <button
                      class="btn btn-secondary dropdown-toggle w-75"
                      type="button"
                      id="dropdownMenu2"
                      data-toggle="dropdown"
                      aria-expanded="false"
                  >
                    {{ buttonText() }}
                  </button>
                  <div class="dropdown-menu w-75" aria-labelledby="dropdownMenu2">
                    <button
                        class="dropdown-item text-dark w-100 router-link-white"
                        type="button"
                        @click="general()"
                    >
                      فاکتور عمومی
                    </button>
                    <button
                        class="dropdown-item text-dark w-100"
                        type="button"
                        @click="simple()"
                    >
                      فاکتور ساده
                    </button>
                    <button
                        class="dropdown-item text-dark w-100"
                        type="button"
                        @click="timeline()"
                    >
                      فاکتور زمان بندی شده
                    </button>
                  </div>
                </div>
              </div>
            </kt-form-group>
          </kt-col>
          <kt-row class="p-2">
            <kt-col lg="6" md="6" xs="12">
              <kt-form-group>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-white text-dark" id="basic-addon1"
                      >نام فاکتور
                      <span class="text-danger">*</span>
                    </span>
                  </div>
                  <input
                    type="text"
                    class="form-control"
                    id="title"
                    name="title"
                    aria-describedby="basic-addon1"
                    v-model="query.title"
                    @change="errors.title = null"
                  />
                  <div v-if="errors.title" class="text-danger text-tiny">{{ errors.title }}</div>
                </div>
              </kt-form-group>
            </kt-col>
            <kt-col lg="6" md="6" xs="12">
              <kt-form-group>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-white text-dark" id="basic-addon1"
                      >شماره فاکتور
                    </span>
                  </div>
                  <input
                    type="text"
                    class="form-control"
                    id="code"
                    name="code"
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                    v-model="query.code"
                    @change="errors.code = null"
                  />
                  <div v-if="errors.code" class="text-danger text-tiny">{{ errors.code }}</div>
                </div>
              </kt-form-group>
            </kt-col>
            <kt-col lg="6" md="6" xs="12">
              <kt-form-group>
                <div class="input-group mb-3">
                  <div v-if="factor_type_general === false" class="input-group-prepend">
                    <span class="input-group-text bg-white text-dark" id="basic-addon1"
                      >مشتریان
                      <span class="text-danger">*</span>
                    </span>
                  </div>
                  <div v-else class="input-group-prepend">
                    <span class="input-group-text bg-white text-dark" id="basic-addon1"
                    >قالب مشتریان
                      <span class="text-danger">*</span>
                    </span>
                  </div>
                  <v-select
                    v-if="factor_type_general === false"
                    v-model="query.customers_id"
                    @input="setSelectedForCustomer"
                    class="vSelect form-control"
                    :options="optionsCustomer"
                    name="customers_id"
                    multiple
                    :filterable="false"
                    @search="onSearchCustomer"
                    :getOptionLabel="(customer) => customer.id"
                  >
                    <template slot="no-options"> مشتری مورد نظر را انتخاب کنید </template>
                    <template slot="option" slot-scope="options">
                      <div class="d-flex align-items-center">
                        {{ options.title }}
                      </div>
                    </template>
                    <template slot="selected-option" slot-scope="options">
                      <div class="selected d-flex align-items-center">
                        {{ options.title }}
                      </div>
                    </template>
                  </v-select>
                  <v-select
                      v-else
                      v-model="query.customer_format_id"
                      @input="setSelectedForCustomer"
                      name="customer_format_it"
                      class="vSelect form-control"
                      :options="optionsCustomerFormat"
                      :filterable="false"
                      @search="onSearchCustomerFormat"
                      :getOptionLabel="(customer_format) => customer_format.id"
                  >
                    <template slot="no-options">قالب مشتری مورد نظر را انتخاب کنید </template>
                    <template slot="option" slot-scope="options">
                      <div class="d-flex align-items-center">
                        {{ options.name }}
                      </div>
                    </template>
                    <template slot="selected-option" slot-scope="options">
                      <div class="selected d-flex align-items-center">
                        {{ options.name }}
                      </div>
                    </template>
                  </v-select>
                </div>
              </kt-form-group>
            </kt-col>
            <kt-col lg="6" md="6" xs="12" v-if="factor_type_simple || factor_type_general">
              <kt-form-group>
                <date-picker
                  v-model="query.simple_sent_date"
                  color="#00c1a4"
                  format="YYYY-MM-DD"
                  display-format="dddd jDD jMMMM jYYYY"
                  placeholder="تاریخ ارسال"
                  id="simple_send_date"
                  :clearable="true"
                  @change="errors.simple_sent_date = null"
                />
                <div v-if="errors.simple_sent_date" class="text-danger text-tiny">{{ errors.simple_sent_date }}</div>
              </kt-form-group>
            </kt-col>
            <kt-col lg="6" md="6" xs="12" v-if="factor_type_simple || factor_type_general">
              <kt-form-group>
                <date-picker
                  v-model="query.simple_due_date"
                  color="#00c1a4"
                  format="YYYY-MM-DD HH:mm:ss"
                  display-format="dddd jDD jMMMM jYYYY"
                  placeholder="تاریخ سر رسید"
                  id="simple_due_date"
                  :clearable="true"
                  @change="errors.simple_due_date = null"
                />
                <div v-if="errors.simple_due_date" class="text-danger text-tiny">{{ errors.simple_due_date }}</div>
              </kt-form-group>
            </kt-col>
            <kt-col lg="6" md="6" xs="12" v-if="factor_type_timeline">
              <kt-form-group>
                <date-picker
                  v-model="query.scheduler_start_date"
                  color="#00c1a4"
                  format="YYYY-MM-DD HH:mm:ss"
                  display-format="dddd jDD jMMMM jYYYY"
                  placeholder="شروع از تاریخ"
                  id="simple_due_date"
                  :clearable="true"
                  @change="errors.scheduler_start_date = null"
                />
                <div v-if="errors.scheduler_start_date" class="text-danger text-tiny">{{ errors.scheduler_start_date }}</div>
              </kt-form-group>
            </kt-col>
            <kt-col lg="6" md="6" xs="12" v-if="factor_type_timeline">
              <kt-form-group>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-white text-dark" id="basic-addon1"
                      >دفعات ارسال
                      <span class="text-danger">*</span>
                    </span>
                  </div>
                  <input
                    type="text"
                    class="form-control"
                    id="scheduler_repeat_cycle_count"
                    name="scheduler_repeat_cycle_count"
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                    v-model="query.scheduler_repeat_cycle_count"
                    @change="errors.scheduler_repeat_cycle_count = null"
                  />
                  <div v-if="errors.scheduler_repeat_cycle_count" class="text-danger text-tiny">{{ errors.scheduler_repeat_cycle_count }}</div>
                </div>
              </kt-form-group>
            </kt-col>
            <kt-col
              lg="9"
              md="9"
              xs="9"
              v-if="factor_type_timeline && factor_timeline_days"
            >
              <kt-form-group>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-white text-dark" id="basic-addon1"
                      >تکرار در هر
                      <span class="text-danger">*</span>
                    </span>
                  </div>
                  <input
                    type="text"
                    class="form-control"
                    id="scheduler_repeat_cycle_days"
                    name="scheduler_repeat_cycle_days"
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                    v-model="query.scheduler_repeat_cycle_days"
                    @change="errors.scheduler_repeat_cycle_days = null"
                  />
                  <div v-if="errors.scheduler_repeat_cycle_days" class="text-danger text-tiny">{{ errors.scheduler_repeat_cycle_days }}</div>
                </div>
              </kt-form-group>
            </kt-col>
            <kt-col
              lg="9"
              md="9"
              xs="9"
              v-if="factor_type_timeline && factor_timeline_weeks"
            >
              <kt-form-group>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-white text-dark" id="basic-addon1"
                      >تکرار در هر
                      <span class="text-danger">*</span>
                    </span>
                  </div>
                  <input
                    type="text"
                    class="form-control"
                    id="scheduler_repeat_cycle_days"
                    name="scheduler_repeat_cycle_days"
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                    v-model="query.scheduler_repeat_cycle_days"
                    @change="errors.scheduler_repeat_cycle_days = null"
                  />
                  <div v-if="errors.scheduler_repeat_cycle_days" class="text-danger text-tiny">{{ errors.scheduler_repeat_cycle_days }}</div>
                </div>
              </kt-form-group>
            </kt-col>
            <kt-col
              lg="9"
              md="9"
              xs="9"
              v-if="factor_type_timeline && factor_timeline_months"
            >
              <kt-form-group>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-white text-dark" id="basic-addon1"
                      >تکرار در هر
                      <span class="text-danger">*</span>
                    </span>
                  </div>
                  <input
                    type="text"
                    class="form-control"
                    id="scheduler_repeat_cycle_days"
                    name="scheduler_repeat_cycle_days"
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                    v-model="query.scheduler_repeat_cycle_days"
                    @change="errors.scheduler_repeat_cycle_days = null"
                  />
                  <div v-if="errors.scheduler_repeat_cycle_days" class="text-danger text-tiny">{{ errors.scheduler_repeat_cycle_days }}</div>
                </div>
              </kt-form-group>
            </kt-col>
            <kt-col
              lg="9"
              md="9"
              xs="9"
              v-if="factor_type_timeline && factor_timeline_years"
            >
              <kt-form-group>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-white text-dark" id="basic-addon1"
                      >تکرار در هر
                      <span class="text-danger">*</span>
                    </span>
                  </div>
                  <input
                    type="text"
                    class="form-control"
                    id="scheduler_repeat_cycle_days"
                    name="scheduler_repeat_cycle_days"
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                    v-model="query.scheduler_repeat_cycle_days"
                    @change="errors.scheduler_repeat_cycle_days = null"
                  />
                  <div v-if="errors.scheduler_repeat_cycle_days" class="text-danger text-tiny">{{ errors.scheduler_repeat_cycle_days }}</div>
                </div>
              </kt-form-group>
            </kt-col>
            <kt-col lg="3" md="3" xs="3" v-if="factor_type_timeline">
              <kt-form-group>
                <div class="dropdown w-100">
                  <button
                    class="btn btn-secondary dropdown-toggle w-100"
                    type="button"
                    id="dropdownMenu2"
                    data-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {{
                      factor_timeline_days
                        ? "روز"
                        : factor_timeline_weeks
                        ? "هفته"
                        : factor_timeline_months
                        ? "ماه"
                        : factor_timeline_years
                        ? "سال"
                        : ""
                    }}
                  </button>
                  <div class="dropdown-menu w-100" aria-labelledby="dropdownMenu2">
                    <button
                      class="dropdown-item text-dark"
                      type="button"
                      @click="factorDays()"
                    >
                      روز
                    </button>
                    <button
                      class="dropdown-item text-dark"
                      type="button"
                      @click="factorWeeks()"
                    >
                      هفته
                    </button>
                    <button
                      class="dropdown-item text-dark"
                      type="button"
                      @click="factorMonths()"
                    >
                      ماه
                    </button>
                    <button
                      class="dropdown-item text-dark"
                      type="button"
                      @click="factorYears()"
                    >
                      سال
                    </button>
                  </div>
                </div>
              </kt-form-group>
            </kt-col>
            <kt-col lg="12" md="12" xs="12" v-if="factor_type_timeline">
              <kt-form-group>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-white text-dark" id="basic-addon1"
                      >سر رسید فاکتور بعد از
                      <span class="text-danger">*</span>
                    </span>
                  </div>
                  <input
                    type="text"
                    class="form-control"
                    id="scheduler_due_days"
                    name="scheduler_due_days"
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                    placeholder="روز"
                    v-model="query.scheduler_due_days"
                    @change="errors.scheduler_due_days = null"
                  />
                  <div v-if="errors.scheduler_due_days" class="text-danger text-tiny">{{ errors.scheduler_due_days }}</div>
                </div>
              </kt-form-group>
            </kt-col>
            <kt-col lg="12" md="12" xs="12">
              <kt-form-group>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-white text-dark" id="basic-addon1"
                      >آیتم
                      <span class="text-danger">*</span>
                    </span>
                  </div>
                  <v-select
                    v-model="query.items"
                    id="items"
                    name="items"
                    @input="setSelectedForItem"
                    class="vSelect form-control"
                    :options="optionsItem"
                    multiple
                    :filterable="false"
                    @search="onSearchItem"
                    :getOptionLabel="(item) => item.item_id"
                    :selectable="optionsItem => optionsItem.quantity !== 0"
                    :class="{'text-red': optionsItem => optionsItem.quantity === 0}"
                  >
                    <template slot="no-options"> آیتم مورد نظر را انتخاب کنید </template>
                    <template slot="option" slot-scope="options">
                      <div
                          class="d-flex align-items-center"
                          :class="{ 'text-danger': options.quantity === 0 , 'text-dark': options.quantity !== 0}"
                      >
                        <span v-show="options.quantity === 0" class="text-danger px-2">ناموجود -</span><span>{{ options.title }}</span>
                      </div>
                    </template>
                    <template slot="selected-option" slot-scope="options">
                      <div class="selected d-flex align-items-center">
                        {{ options.title }}
                      </div>
                    </template>
                  </v-select>
                  <div v-if="errors.items && query.items.length === 0" class="text-danger text-tiny">{{ errors.items }}</div>
                </div>
              </kt-form-group>
            </kt-col>
            <div
              class="col-md-4 my-1"
              v-for="(item, idx) in query.items"
              :key="idx"
            >
              <div class="card col-md-12 p-0 h-100">
                <div class="card-body d-flex">
                  <div class="col-md-6">
                    <img v-if="item.image === null" src="../../../assets/media/item.png" alt="" class="img-fluid" style="height:150px;">
                    <img v-else
                      :src="`${item.image}`"
                      alt=""
                    />
                  </div>
                  <div
                    class="col-md-6 ml-3 d-flex flex-column align-items-center justify-content-between"
                  >
                    <div class="text-dark py-3 w-100" id="itemsTitle">{{ item.title }}</div>
                    <p>{{ Number(item.amount).toLocaleString()  + ' ریال'}}</p>
                  </div>
                </div>
                <div class="card-body d-flex align-items-center card-b-t w-100">
                  <div v-if="!factor_type_general" class="col-3">
                    <button
                      type="button"
                      class="btn text-primary w-100"
                      @click="increase(item, idx)"
                      style="text-align: center"
                    >
                      <i class="fa fa-plus"></i>
                    </button>
                  </div>
                  <div class="col-3">
                    <span class="text-center form-control border-0 bg-secondary" style="width: 50px">{{ item.number }}</span>
                  </div>
                  <div v-if="!factor_type_general" class="col-3">
                    <button
                      type="button"
                      class="btn text-primary w-100"
                      @click="decrease(item, idx)"
                      style="text-align: center"
                    >
                      <i class="fa fa-minus"></i>
                    </button>
                  </div>
                  <div class="col-3">
                    <button
                      type="button"
                      class="btn text-danger w-100"
                      @click="removeQ(item)"
                      style="text-align: center"
                    >
                      <i class="fa fa-trash"></i>
                    </button>
                  </div>
                </div>
                <div v-if="factor_type_general" class="card-body d-flex justify-content-center align-items-center card-b-t w-100">
                  <div class="d-flex justify-content-between w-100">
                    <label class="form-check-label" for="items_count">امکان انتخاب تعداد کالا توسط کاربر</label>
                    <label class="switch">
                      <input
                          type="checkbox"
                          id="items_count"
                          v-model="item.quantity_selection"
                      />
                      <span class="slider round"></span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <kt-col lg="12" md="12" xs="12">
              <kt-form-group>
                <div class="input-group mt-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-white text-dark" id="basic-addon1"
                      >هزینه حمل و نقل
                      <span class="text-danger">*</span>
                    </span>
                  </div>
                  <input
                    type="number"
                    id="shipping_cost"
                    name="shipping_cost"
                    class="form-control"
                    aria-describedby="basic-addon1"
                    v-model="query.shipping_cost"
                    @change="errors.shipping_cost = null"
                  />
                  <div v-if="errors.shipping_cost" class="text-danger text-tiny">{{ errors.shipping_cost }}</div>
                </div>
                <span class="badge badge-light my-2 d-block w-25">
                  {{ Number(query.shipping_cost).toLocaleString() + " ریال" }}
                </span>
                  
              </kt-form-group>
            </kt-col>
            <kt-col v-if="!factor_type_general" lg="3" md="3" xs="12">
              <kt-form-group>
                <div class="dropdown w-100">
                  <button
                    class="btn btn-secondary dropdown-toggle w-100"
                    type="button"
                    id="dropdownMenu2"
                    data-toggle="dropdown"
                    aria-expanded="false"
                  >
                    انتخاب نوع تخفیف
                  </button>
                  <div class="dropdown-menu w-100" aria-labelledby="dropdownMenu2">
                    <button
                      class="dropdown-item text-dark w-100"
                      type="button"
                      @click="factorDiscountAmount()"
                    >
                      مبلغ
                    </button>
                    <button
                      class="dropdown-item text-dark w-100"
                      type="button"
                      @click="factorDiscountPercent()"
                    >
                      درصد
                    </button>
                  </div>
                </div>
              </kt-form-group>
            </kt-col>
            <kt-col lg="9" md="9" xs="12" v-if="!factor_type_general && factor_discount_amount">
              <kt-form-group>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-white text-dark" id="basic-addon1">
                      ریال
                      <span class="text-danger">*</span>
                    </span>
                  </div>
                  <input
                    type="number"
                    class="form-control w-50"
                    id="discount_amount"
                    name="discount_amount"
                    aria-describedby="basic-addon1"
                    v-model="query.discount_amount"
                  />
                </div>
                <span class="badge badge-light my-2 d-block w-25">{{
                  Number(query.discount_amount).toLocaleString() + " ریال"
                }}</span>
              </kt-form-group>
            </kt-col>
            <kt-col lg="9" md="9" xs="9" v-if="!factor_type_general && factor_discount_percent">
              <kt-form-group>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-white text-dark" id="basic-addon1">
                      درصد
                      <span class="text-danger">*</span>
                    </span>
                  </div>
                  <input
                    type="number"
                    min="0"
                    max="100"
                    class="form-control w-25"
                    id="discount_percent"
                    name="discount_percent"
                    aria-describedby="basic-addon1"
                    v-model="query.discount_percent"
                    @change="errors.discount_amount = null"
                  />
                  <div v-if="errors.discount_amount" class="text-danger text-tiny">{{ errors.discount_amount }}</div>
                </div>
              </kt-form-group>
            </kt-col>
            <kt-col v-if="factor_type_general" lg="12" md="12" xs="12">
              <kt-form-group>
                <div class="mb-3">
                  <div class="d-block">
                    <span
                        class="d-flex align-items-center my-1 bg-white text-dark"
                        id="basic-addon1"
                    >کد تخفیف
                      <span class="text-danger">*</span>
                      <span>
                        <router-link
                            to="/online-factor/create-discount"
                            class="badge badge-success mx-3 p-2"
                        >
                          + ایجاد کد تخفیف
                        </router-link>
                      </span>
                    </span>
                  </div>
                  <v-select
                      v-model="query.discounts"
                      id="discounts"
                      name="discounts"
                      class="vSelect form-control vSelect-Dark-theme"
                      :options="optionsDiscounts"
                      multiple
                      :filterable="false"
                      @search="onSearchDiscount"
                      :getOptionLabel="(discount) => discount.id"
                  >
                    <template slot="no-options">کد تخفیف مورد نظر را جستجو کنید </template>
                    <template slot="option" slot-scope="options">
                      <div class="d-flex align-items-center text-dark">
                        {{ options.code }}
                      </div>
                    </template>
                    <template slot="selected-option" slot-scope="options">
                      <div class="selected d-flex align-items-center">
                        {{ options.code }}
                      </div>
                    </template>
                  </v-select>
                  <div v-if="errors.discounts && query.discounts.length === 0" class="text-danger text-tiny">{{ errors.discounts }}</div>
                </div>
              </kt-form-group>
            </kt-col>
            <kt-col lg="12" md="12" xs="12">
              <kt-form-group>
                <div class="bg-factor text-dark">
                  <div class="card-body">
                    <div class="d-flex align-item-center justify-content-between">
                      <div>
                        <p class="font-weight-bold">هزینه آیتم ها</p>
                        <p class="font-weight-bold">هزینه حمل و نقل</p>
                        <p class="font-weight-bold">تخفیف</p>
                        <h5 class="font-weight-bold text-primary">جمع کل</h5>
                      </div>
                      <div>
                        <p>
                          {{
                            itemsSelected.length === 0
                              ? "0"
                              :  Number(itemsAmount).toLocaleString() 
                          }}
                          ریال
                        </p>
                        <p>
                          {{
                            query.shipping_cost === "0"
                              ? "0"
                              : Number(query.shipping_cost).toLocaleString()
                          }}
                          ریال
                        </p>
                        <p v-if="factor_discount_amount">
                          {{
                            query.discount_amount === "0"
                              ? "0"
                              : Number(query.discount_amount).toLocaleString()
                          }}
                          ریال
                        </p>
                        <p v-if="factor_discount_percent">
                          {{
                            query.discount_percent === "0"
                              ? "0"
                              : Number(query.discount_percent)
                          }}
                          درصد
                        </p>
                        <p class="text-primary">
                          {{ Number(finalPrice).toLocaleString() }} ریال
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </kt-form-group>
            </kt-col>
            <kt-col lg="12" md="12" xs="12">
              <div class="custom-control custom-switch mb-3">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="customSwitch1"
                  v-model="factor_has_message"
                />
                <label class="custom-control-label" for="customSwitch1"
                  >پیغام به مشتری</label
                >
              </div>
            </kt-col>
            <kt-col lg="9" md="9" xs="12" v-if="factor_has_message">
              <kt-form-group>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-white text-dark" id="basic-addon1"
                      >پیغام به مشتری
                      <span class="text-danger">*</span>
                    </span>
                  </div>
                  <input
                    type="text"
                    class="form-control"
                    id="message"
                    name="message"
                    aria-describedby="basic-addon1"
                    v-model="query.message"
                  />
                </div>
              </kt-form-group>
            </kt-col>
            <kt-col lg="3" md="3" xs="12" v-if="factor_has_message">
              <kt-form-group>
                <div class="d-flex align-items-center w-100">
                  <div class="dropdown w-100">
                    <button
                      class="btn btn-secondary dropdown-toggle w-100"
                      type="button"
                      id="dropdownMenu2"
                      data-toggle="dropdown"
                      aria-expanded="false"
                    >
                      {{
                        factor_message_type === 1
                          ? "نمایش پیغام بعد از پرداخت"
                          : "نمایش پیغام قبل و بعد از پرداخت"
                      }}
                    </button>
                    <div class="dropdown-menu w-100" aria-labelledby="dropdownMenu2">
                      <button
                        class="dropdown-item text-dark"
                        type="button"
                        @click="afterPayMsg()"
                      >
                        نمایش پیغام بعد از پرداخت
                      </button>
                      <button
                        class="dropdown-item text-dark"
                        type="button"
                        @click="BeforeandAfterPaymsg()"
                      >
                        نمایش پیغام قبل و بعد از پرداخت
                      </button>
                    </div>
                  </div>
                </div>
              </kt-form-group>
            </kt-col>
            <kt-col lg="12" md="12" xs="12">
              <div class="custom-control custom-switch mb-3">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="customSwitch2"
                  v-model="factor_has_rules"
                />
                <label class="custom-control-label" for="customSwitch2"
                  >قوانین فاکتور</label
                >
              </div>
            </kt-col>
            <kt-col lg="9" md="9" xs="12" v-if="factor_has_rules">
              <kt-form-group>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-white text-dark" id="basic-addon1"
                      >قوانین
                      <span class="text-danger">*</span>
                    </span>
                  </div>
                  <input
                    type="text"
                    id="rules"
                    name="rules"
                    class="form-control"
                    aria-describedby="basic-addon1"
                    v-model="query.rules"
                  />
                </div>
              </kt-form-group>
            </kt-col>
            <kt-col lg="3" md="3" xs="12" v-if="factor_has_rules">
              <kt-form-group>
                <div class="d-flex align-items-center w-100">
                  <div class="dropdown w-100">
                    <button
                      class="btn btn-secondary dropdown-toggle w-100"
                      type="button"
                      id="dropdownMenu2"
                      data-toggle="dropdown"
                      aria-expanded="false"
                    >
                      {{
                        factor_rules_type === 1
                          ? "نمایش پیغام بعد از پرداخت"
                          : "نمایش پیغام قبل و بعد از پرداخت"
                      }}
                    </button>
                    <div class="dropdown-menu w-100" aria-labelledby="dropdownMenu2">
                      <button
                        class="dropdown-item text-dark"
                        type="button"
                        @click="afterPayRules()"
                      >
                        نمایش پیغام بعد از پرداخت
                      </button>
                      <button
                        class="dropdown-item text-dark"
                        type="button"
                        @click="BeforeandAfterPayrules()"
                      >
                        نمایش پیغام قبل و بعد از پرداخت
                      </button>
                    </div>
                  </div>
                </div>
              </kt-form-group>
            </kt-col>

            <kt-col lg="12" md="12" xs="12">
              <kt-button
                id="form-btn"
                class="btn btn-success btn-wide text-center py-2"
                type="submit"
                variant="success"
              >
                ارسال فاکتور
              </kt-button>
            </kt-col>
          </kt-row>
        </kt-form-section>
      </div>
    </form>
  </kt-panel>
</template>

<script>
import $ from "jquery";
import _ from "lodash";
import toastr from "toastr";
import { KTApp } from "@/plugins/core/app";
import { onlineFactorService } from '@/common/api.service';

export default {
  props: {
    submitSingleRequest: {
      default: function ($event, query) {},
      type: Function,
    },
  },
  data() {
    return {
      query: {
        is_unlimited: false,
        shipping_cost: "",
        discount_amount: "",
        discount_percent: "",
        customers_id: [],
        customer_format_id: null,
        items: [],
        discounts: []
      },
      customersSelected: [],
      itemsSelected: [],
      optionsCustomer: [],
      optionsItem: [],
      optionsDiscounts: [],
      factor_type_timeline: false,
      factor_type_simple: false,
      factor_type_general: true,
      optionsCustomerFormat: [],
      selectedItem: [],
      factor_timeline_days: true,
      factor_timeline_weeks: false,
      factor_timeline_months: false,
      factor_timeline_years: false,
      factor_discount_amount: true,
      factor_discount_percent: false,
      factor_has_message: false,
      factor_message_type: 1,
      factor_has_rules: false,
      factor_rules_type: 1,
      itemsPrice: "",
      errors: {
        title: null,
        code: null,
        customers_id: null,
        customer_format_id: null,
        items: null,
        shipping_cost: null,
        discount_amount: null,
        discount_percent: null,
        message: null,
        simple_due_date: null,
        simple_sent_date: null,
        rules: null,
        scheduler_start_date: null,
        scheduler_repeat_cycle_days: null,
        scheduler_repeat_cycle_count: null,
        scheduler_due_days: null,
        discounts: null
      }
    };
  },
  computed: {
    toastr() {
      toastr.options = {
        closeButton: true,
        positionClass: "toast-bottom-center",
        preventDuplicates: true,
        rtl: false,
      };

      return toastr;
    },
    finalPrice() {
      // fix this part later

      var fPrice = 0;
      if (this.factor_discount_amount) {
        //   for amount
        fPrice = Number(this.itemsAmount) + Number(this.query.shipping_cost) - Number(this.query.discount_amount);
      }
      if (this.factor_discount_percent) {
        //   for percent
        fPrice =
          Number(this.itemsAmount) + Number(this.query.shipping_cost) -
          ((Number(this.query.shipping_cost) + Number(this.itemsAmount)) * Number(this.query.discount_percent)) / 100;
      }
      return fPrice;
    },
    itemsAmount(){
      var totalAmount = 0;
      this.itemsSelected.map( item =>{
        totalAmount+=Number(item.amount) * Number(item.number)
      })
      return totalAmount
    }
  },
  methods: {
    increase(item, index){
      if (this.query.items[index].quantity <= 1){
        this.toastr.error('موجودی محصول مورد نظر کافی نیست!');
      }else {
        item.number++
        this.query.items[index].quantity--
      }
    },
    // SetSelected
    setSelectedForCustomer(value) {
      for (let id in value) {
        this.customersSelected.push(value[id].id);
      }
      function removeDuplicates(arr) {
        return arr.filter((item, index) => arr.indexOf(item) === index);
      }
      this.customersSelected = removeDuplicates(this.customersSelected);
    },
    //OnSearch for discount
    onSearchDiscount(search, loading) {
      this.errors.discounts = null
      this.searchDiscount(loading, search, this)
    },
    searchDiscount: _.debounce((loading, search, vm) => {
      let params = {
        code: search,
        is_search: 1
      }
      onlineFactorService.getDiscount(params)
          .then(response => {
            vm.optionsDiscounts = response.data.data
          })
    }, 600),
    // For Items Selected
    setSelectedForItem(value) {
      this.itemsSelected = value;
    },
    // OnSearch for Customers
    onSearchCustomer(search, loading) {
      this.searchForCustomer(loading, search, this);
    },
    searchForCustomer: _.debounce((loading, search, vm) => {
      let token = localStorage.getItem("access_token");
      onlineFactorService
        .factorCustomerSearch(search, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          vm.optionsCustomer = res.data;
          loading(false);
        })
        .catch((e) => {
          console.log(e);
        });
    }, 600),
    // OnSearch for Items
    onSearchItem(search, loading) {
      this.searchForItem(loading, search, this);
    },
    searchForItem: _.debounce((loading, search, vm) => {
      let token = localStorage.getItem("access_token");
      onlineFactorService
        .factorItemSearch(search, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          vm.optionsItem = res.data;
          vm.selectedItem = res.data;
          loading(false);
        })
        .catch((e) => {
          console.log(e);
        });
    }, 600),
    currencyFormat(price) {
      price = Math.floor(price / 10);
      const pieces = parseFloat(price).toFixed(0).split("");
      let ii = pieces.length;

      while ((ii -= 3) > 0) {
        pieces.splice(ii, 0, ",");
      }

      return pieces.join("");
    },
    processFile(e) {
      this.factor.file = e.target.files[0];
      let output = document.getElementById("pic_preview");
      output.src = URL.createObjectURL(e.target.files[0]);
      output.onload = function () {
        URL.revokeObjectURL(output.src); // free memory
      };
    },
    submitRequest(e, query) {
      let form = $("#single-request-form");
      let btn = $("#form-btn");
      form.validate({
        rules: {
          title: {
            required: true,
          },
          code: {
            required: false,
          },
          customers_id: {
            required: true,
          },
          items: {
            required: true,
          },
          shipping_cost: {
            required: true,
          },
          discount_amount: {
            required: true,
          },
          message: {
            required: true,
          },
          rules: {
            required: true,
          },
          scheduler_start_date: {
            required: true,
          },
          scheduler_repeat_cycle_days: {
            required: true,
          },
          scheduler_repeat_cycle_count: {
            required: true,
          },
          scheduler_due_days: {
            required: true,
          },
        },
      });

      if ((!this.query.simple_due_date || !this.query.simple_sent_date) && this.factor_type_simple) {
        if (!this.query.simple_due_date) {
          this.errors.simple_due_date = 'تکمیل این فیلد اجباری است.'
        }

        if (!this.query.simple_sent_date) {
          this.errors.simple_sent_date = 'تکمیل این فیلد اجباری است.'
        }

        return;
      }

      if (this.factor_type_general && query.discounts.length === 0) {
        this.errors.discounts = 'تکمیل این فیلد اجباری است.'
        return;
      }

      if (!form.valid()) return;
      if (query.items.length === 0 || (query.customers_id.length === 0 && query.customer_format_id.length ===0)) {
        if (query.items.length === 0)
          this.errors.items = "تکمیل این فیلد اجباری است."

        if (query.customers_id.length === 0)
          this.errors.customers_id = "تکمیل این فیلد اجباری است."

        return;
      }

      this.itemsSelected.forEach((obj) => {
        delete obj["title"];
        delete obj["image"];
        delete obj["amount"];
      });

      let factor_type = null

      if (this.factor_type_simple) {
        factor_type = 1
      } else if(this.factor_type_timeline) {
        factor_type = 2
      } else {
        factor_type = 3
      }

      let data = {
        title: query.title,
        code: query.code ? query.code : "",
        type: factor_type,
        simple_sent_date: (this.factor_type_simple || this.factor_type_general) ? query.simple_sent_date : "",
        simple_due_date: (this.factor_type_simple || this.factor_type_general) ? query.simple_due_date : "",
        scheduler_start_date: this.factor_type_timeline ? query.scheduler_start_date : "",
        scheduler_repeat_cycle_days:
          this.factor_type_timeline && this.factor_timeline_days
            ? query.scheduler_repeat_cycle_days
            : this.factor_type_timeline && this.factor_timeline_weeks
            ? query.scheduler_repeat_cycle_days * 7
            : this.factor_type_timeline && this.factor_timeline_months
            ? query.scheduler_repeat_cycle_days * 30
            : this.factor_type_timeline && this.factor_timeline_years
            ? query.scheduler_repeat_cycle_days * 365
            : "",
        scheduler_repeat_cycle_count: this.factor_type_timeline
          ? query.scheduler_repeat_cycle_count
          : "",
        scheduler_due_days: this.factor_type_timeline ? query.scheduler_due_days : "",
        shipping_cost: query.shipping_cost ? query.shipping_cost : 0,
        discount_amount: this.factor_discount_amount ? query.discount_amount : "",
        discount_percent: this.factor_discount_percent ? query.discount_percent : "",
        has_message: this.factor_has_message,
        message_type: this.factor_message_type,
        message: this.factor_has_message ? query.message : "",
        has_rules: this.factor_has_rules,
        rule_type: this.factor_rules_type,
        rules: this.factor_has_rules ? query.rules : "",
        has_signature: false,
        payment_after_due_date: true,
        customers_id: (this.factor_type_simple || this.factor_type_timeline) ? query.customers_id.map(item => item.id) : null,
        customer_format_id: this.factor_type_general ? query.customer_format_id.id : null,
        items: query.items.map(item => ( {item_id: item.item_id , number: item.number, quantity_selection: item.quantity_selection} )),
        discounts: this.factor_type_general ? query.discounts.map(item => item.id) : null
      };

      KTApp.progress(btn);

      let tokenStr = localStorage.getItem("access_token");
      onlineFactorService
        .createFactor(data, { headers: { Authorization: `Bearer ${tokenStr}` } })
        .then((response) => {
          this.$router.push("/factors");
        })
        .catch(({ response }) => {
          this.toastr.error(response.data.message);
          for (let err in response.data.data) {
            this.toastr.error(response.data.data[err][0]);
          }
        })
        .finally((response) => {
          KTApp.unprogress(btn);
        });

    },
    resetData() {
      this.query = {
        is_unlimited: false,
        shipping_cost: 0,
        discount_amount: 0,
        discount_percent: 0,
        customers_id: [],
        customer_format_id: null,
        items: []
      }
      this.errors = {
        title: null,
        code: null,
        customers_id: null,
        customer_format_id: null,
        items: null,
        shipping_cost: null,
        discount_amount: null,
        discount_percent: null,
        message: null,
        simple_due_date: null,
        simple_sent_date: null,
        rules: null,
        scheduler_start_date: null,
        scheduler_repeat_cycle_days: null,
        scheduler_repeat_cycle_count: null,
        scheduler_due_days: null,
      }
    },
    buttonText() {
      if (this.factor_type_general) {
        return 'فاکتور عمومی'
      }

      if (this.factor_type_simple) {
        return 'فاکتور ساده یک بار مصرف'
      }

      if (this.factor_type_timeline) {
        return 'فاکتور زمان بندی شده یک بار مصرف'
      }
    },
    timeline() {
      this.factor_type_timeline = true;
      this.factor_type_simple = false;
      this.factor_type_general = false;
      this.resetData()
    },
    simple() {
      this.factor_type_simple = true;
      this.factor_type_timeline = false;
      this.factor_type_general = false;
      this.resetData()
    },
    general() {
      this.factor_type_simple = false;
      this.factor_type_timeline = false;
      this.factor_type_general = true;
      this.resetData()
    },
    factorDays() {
      this.factor_timeline_days = true;
      this.factor_timeline_weeks = false;
      this.factor_timeline_months = false;
      this.factor_timeline_years = false;
    },
    factorWeeks() {
      this.factor_timeline_days = false;
      this.factor_timeline_weeks = true;
      this.factor_timeline_months = false;
      this.factor_timeline_years = false;
    },
    factorMonths() {
      this.factor_timeline_months = true;
      this.factor_timeline_weeks = false;
      this.factor_timeline_days = false;
      this.factor_timeline_years = false;
    },
    factorYears() {
      this.factor_timeline_years = true;
      this.factor_timeline_weeks = false;
      this.factor_timeline_days = false;
      this.factor_timeline_months = false;
    },
    removeQ(item) {
      if (item.number) {
        var findIdx = this.query.items.indexOf(item);
        this.query.items.splice(findIdx, 1);
      } else {
        item.number--;
      }
    },
    decrease(item, index) {
      if (item.number > 1) {
        item.number--;
        this.query.items[index].quantity++
      } else {
        item.number = 1;
      }
    },
    factorDiscountAmount() {
      this.factor_discount_amount = true;
      this.factor_discount_percent = false;
    },
    factorDiscountPercent() {
      this.factor_discount_amount = false;
      this.factor_discount_percent = true;
    },
    afterPayMsg() {
      this.factor_message_type = 1;
    },
    BeforeandAfterPaymsg() {
      this.factor_message_type = 2;
    },
    factorHasRules() {
      this.factor_has_rules = true;
    },
    factorNotRules() {
      this.factor_has_rules = false;
    },
    afterPayRules() {
      this.factor_rules_type = 1;
    },
    BeforeandAfterPayrules() {
      this.factor_rules_type = 2;
    },
    onSearchCustomerFormat(search, loading) {
      this.errors.customer_format_id = null
      this.searchForCustomerFormat(loading, search, this);
    },
    searchForCustomerFormat: _.debounce((loading, search, vm) => {
      onlineFactorService
          .getFactorCustomerFormat({name: search})
          .then((res) => {
            vm.optionsCustomerFormat = res.data.data.data;
            loading(false);
          })
          .catch((error) => {
            throw new Error(error)
          });
    }, 600),
  },
};
</script>
<style scoped>
.preview_img {
  max-width: 70px;
  max-height: 70px;
  position: absolute;
  top: 10px;
  left: 80px;
}

textarea {
  resize: none;
}

#numberItems {
  text-align: center;
}

.bg-factor {
  border-radius: 11px;
  background: linear-gradient(
    180deg,
    rgba(53, 206, 183, 0.05) 100%,
    rgba(255, 255, 255, 1) 100%
  );
}

.custom-file-upload {
  display: none;
}

.file-label {
  border: 1px dashed gray;
  color: #333;
  height: 100px;
  width: 250px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  cursor: pointer;
}

.btn.dropdown-toggle:after {
  padding-right: 50px;
}

.vSelect {
  --vs-actions-padding: 0;
  --vs-border-color: #fff;
}

.cursor_pointer {
  cursor: pointer;
}

.card {
  border: 1px solid #e9e9e9 !important;
}

.img-border {
  border: 1px solid red;
}

.card-b-t {
  border-top: 1px solid #e9e9e9;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  -moz-appearance: textfield;
}

#itemsTitle{
  font-size: 15px;
  width: 100%;
}

@media screen and (max-width:1000px){
  .btn.dropdown-toggle:after {
  padding-right: 30px;
}
}
</style>
